import React, { useState } from "react";
import { Dropdown, FormControl } from "react-bootstrap";
import "../../App.css";

export default function CustomTreeSelect({
  data,
  value,
  placeholder,
  onChange,
}) {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filterItems = (items) => {
    let filteredItems = [];

    items.forEach((item) => {
      const hasChildren = item.children && item.children.length > 0;

      if (
        item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (hasChildren && filterItems(item.children).length > 0)
      ) {
        filteredItems.push({
          ...item,
          children: hasChildren ? filterItems(item.children) : [],
        });
      }
    });

    return filteredItems;
  };

  const renderDropdownItems = (items, level = 0, hierarchy = []) => {
    return items.map((item) => {
      const hasChildren = item.children && item.children.length > 0;

      const newHierarchy = [...hierarchy, item.value]; // Accumulate the hierarchy

      return (
        <React.Fragment key={item.value}>
          <Dropdown.Item
            onClick={() => !hasChildren && onChange(item, newHierarchy)}
            style={{
              paddingLeft: `${level * 20 + 15}px`,
              color: hasChildren ? "gray" : "black",
            }}
            disabled={hasChildren}
          >
            {item.title}
          </Dropdown.Item>
          {hasChildren &&
            renderDropdownItems(item.children, level + 1, newHierarchy)}
        </React.Fragment>
      );
    });
  };

  const filteredData = filterItems(data);

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="light"
        style={{
          width: "100%",
          textAlign: "left",
          textTransform: "capitalize",
          lineHeight: "0.76",
        }}
      >
        {value === null || value === "" ? placeholder : value}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <FormControl
          autoFocus
          className="mx-1 my-2"
          style={{
            width: "180px",
          }}
          placeholder="Search..."
          onChange={handleSearch}
          value={searchTerm}
        />
        {renderDropdownItems(filteredData)}
      </Dropdown.Menu>
    </Dropdown>
  );
}
